// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upload-detail {\r\n  margin-top: -30px;\n}\n.information {\r\n  width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
